import React from 'react'

import { SidebarProvider } from '@/components/ui/sidebar'
import useLocalStorage from '@/hooks/useLocalStorage'
import { LOCAL_STORAGE_KEYS } from '@/lib/constants'

interface Props {
  children: React.ReactNode
}

/**
 * Wraps the dashboard layouts with the shadcn `SidebarProvider`, persisting the
 * desktop expanded/collapsed preference to local storage.
 */
const DashboardSidebarProvider: React.FC<Props> = ({ children }) => {
  const [isExpanded, setIsExpanded] = useLocalStorage(
    LOCAL_STORAGE_KEYS.isDesktopSidebarExpanded,
    true,
  )

  return (
    <SidebarProvider
      open={isExpanded}
      onOpenChange={setIsExpanded}
      className="min-w-75 items-stretch"
    >
      {children}
    </SidebarProvider>
  )
}

export default DashboardSidebarProvider
